import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { supabase } from '../../supabaseClient';
import './header.css';
import Logo from "../../assets/MUFA - LOGO - Trang.jpg";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const { lang, setLang, t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  // Fetch categories from Supabase
  const fetchCategories = async () => {
    if (!supabase) return;
    try {
      const { data, error } = await supabase
        .from('categories')
        .select('*')
        .order('sort_order', { ascending: true });

      if (error) throw error;
      if (data) {
        setCategories(data);
      }
    } catch (err) {
      console.error('Error fetching categories in Header:', err);
    }
  };

  useEffect(() => {
    fetchCategories();

    // Re-fetch on focus or route change to ensure sync after admin edits
    window.addEventListener('focus', fetchCategories);

    // Optional Supabase real-time channel for instant updates
    let channel = null;
    if (supabase) {
      channel = supabase
        .channel('header-categories-changes')
        .on('postgres_changes', { event: '*', schema: 'public', table: 'categories' }, fetchCategories)
        .subscribe();
    }

    return () => {
      window.removeEventListener('focus', fetchCategories);
      if (channel && supabase) {
        supabase.removeChannel(channel);
      }
    };
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    closeMenu();

    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
      navigate(`/#${sectionId}`, { replace: true });
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  return (
    <header className="main-header">
      <div className="header-container">
        <div className="logo-box">
          <Link to="/" onClick={closeMenu}>
            <img src={Logo} alt="Logo" className='logo-img' decoding="async" />
          </Link>
        </div>

        <div 
          className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`} 
          onClick={toggleMenu}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        <nav className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          {categories.length > 0 ? (
            categories.map((cat) => {
              const titleToShow = (lang === 'en' && cat.title_en) ? cat.title_en : cat.title;
              return (
                <Link 
                  key={cat.id || cat.key} 
                  to={`/#${cat.key}`} 
                  onClick={(e) => handleNavClick(e, cat.key)}
                >
                  {titleToShow}
                </Link>
              );
            })
          ) : (
            <>
              <Link to="/#about-section" onClick={(e) => handleNavClick(e, 'about-section')}>{t('nav_about')}</Link>
              <Link to="/#menu-section" onClick={(e) => handleNavClick(e, 'menu-section')}>{t('nav_menu')}</Link>
              <Link to="/#press-section" onClick={(e) => handleNavClick(e, 'press-section')}>{t('nav_press')}</Link>
              <Link to="/#activities-section" onClick={(e) => handleNavClick(e, 'activities-section')}>{t('nav_activities')}</Link>
              <Link to="/#art-section" onClick={(e) => handleNavClick(e, 'art-section')}>{t('nav_art')}</Link>
            </>
          )}

          <div className="lang-switcher-btn">
            <span 
              className={`lang-option ${lang === 'vi' ? 'active' : ''}`}
              onClick={() => setLang('vi')}
            >
              VN
            </span>
            <span className="lang-divider">|</span>
            <span 
              className={`lang-option ${lang === 'en' ? 'active' : ''}`}
              onClick={() => setLang('en')}
            >
              EN
            </span>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;